<div class="property-card-final">
    <div class="card-image-section-final">
        <img src="assets/images/building.jpg" alt="Shantam Parmeshwar Apartment Building">
        <div class="image-badges-final">
            <span class="badge-final badge-rera-final"> RERA</span>
            <span class="badge-final badge-seen-final">Seen</span>
        </div>
        <div class="image-count-final">
            <span> 11</span>
        </div>
        <span class="like-icon-final">🤍</span>
    </div>

    <div class="card-details-section-final">
        <div class="header-row-final">
            <h3 class="property-title-final">Shantam Parmeshwar</h3>
            <span class="best-offer-tag-final">BEST OFFER</span>

        </div>

        <p class="property-subtitle-final">3 BHK Flat In Gota, Ahmedabad</p>

<div class="feature-grid-final">
  <!-- Row 1 -->
  <div class="feature-item-final">
    <span class="feature-value-final">3 BHK Flat</span>
  </div>
  <div class="vertical-line-final"></div>
  <div class="feature-item-final">
    <span class="feature-value-final">1815 - 2116 Sq-ft</span>
  </div>
  <div class="vertical-line-final"></div>
  <div class="feature-item-final price-item-final">
    <span class="feature-value-final price-final">₹98.92 L - ₹1.15 Cr</span>
  </div>

  <!-- Divider -->
  <div class="divider-final"></div>

  <!-- Row 2 -->
  <div class="feature-item-final">
    <span class="feature-value-final">3 BHK Penthouse</span>
    <span class="feature-label-final">Under Construction</span>
  </div>
  <div class="vertical-line-final"></div>
  <div class="feature-item-final">
    <span class="feature-value-final">1984 - 2211 Sq-ft</span>
    <span class="feature-label-final">(Super Builtup Area)</span>
  </div>
  <div class="vertical-line-final"></div>
  <div class="feature-item-final price-item-final">
    <span class="feature-value-final price-final">₹1.08 Cr - ₹1.20 Cr</span>
    <span class="feature-label-final secondary-price-final">₹5,450 / Sq-ft</span>
  </div>
</div>




        <div class="mini-features-final">
            <span>Zero Brokerage</span>
            &bull;
            <span>Possession: December 2028</span>
            &bull;
            <span>Residential With Retail</span>
            &bull;
            <span>Rera Id</span>
        </div>

        <div class="locality-details-final">
            <span class="detail-item-final">Hospital within 2 km to 6.4 km</span>
            <span class="detail-item-final">School within 0.65 km to 4.3 km</span>
            <span class="detail-item-final">Railway Sta</span>
        </div>

        <div class="card-footer-final">
            <div class="builder-info-final">
                <p>Builder</p>
                <p class="builder-name-final">Dobariya Group</p>
            </div>
           <div class="cta-buttons-final">
    <button class="icon-btn-final whatsapp-btn-final">
        <i class="fab fa-whatsapp"></i>
    </button>
    <button class="icon-btn-final call-btn-final">
        <i class="fas fa-phone"></i>
    </button>
    <button class="brochure-btn-final">
        <i class="fas fa-download"></i> Brochure
    </button>
    <button class="get-offer-btn-final">
        Get Offer
    </button>
</div>  
        </div>
    </div>
</div>